/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import React, { Component } from 'react';
import { Spinner } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import AccountService from '../../services/account.service';
import AlertService from '../../services/alerts.service';
import ScheduleService from '../../services/schedule.service';
import HomeService from '../../services/home.service';
import PartnerService from '../../services/partner.service';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import BaseAlertPage from '../LWTriageAlerts/BaseAlertPage';
import ReplaceSystemModal from "./ReplaceSystemModal";
import memoize from 'memoize-one';
import moment from 'moment';

import {
    jsTechnician,
    jsHouse,
    jsDetails,
    jsOpportunity,
    jsCustomer,
    jsComponent,
    alertSearchStartDate,
    jsScheduleDetails
} from "../../componentObjects";
import { PageView, ModalView, Event, Timing } from "../GoogleAnalytics";

import hvaccomponentService from "../../services/hvaccomponent.service";
import appointmentService from "../../services/appointment.service";
import AssetService from "../../services/asset.service";
import alerttypemessagingservice from "../../services/alerttypemessaging.service";
import Loader from "../Loader/Loader";
import ArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AlertDetailsModal from "../ScheduleRepairs/AlertDetailsModal";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import UpdateJobModal from "../ScheduleRepairs/UpdateJobModal";
import ServiceTitanService from "../../services/servicetitan.service";

class CurrentJob extends Component {
    static displayName = CurrentJob.name;
    _isMounted = false;

    constructor(props) {
        super(props);

        this.getAlerts = this.getAlerts.bind(this);
        this.reloadTable = this.reloadTable.bind(this);
        this.reloadOppTable = this.reloadOppTable.bind(this);
        this.changeRadio = this.changeRadio.bind(this);
        
        this.onAlertCancelClick = this.onAlertCancelClick.bind(this);
        this.onCancelUpdateClick = this.onCancelUpdateClick.bind(this);
        this.openAlertDetailsModal = this.openAlertDetailsModal.bind(this);
        this.onDetailsClick = this.onDetailsClick.bind(this);
        this.openUpdateJobModal = this.openUpdateJobModal.bind(this);
        this.showUpdateJobModal = this.showUpdateJobModal.bind(this);
        this.openDeferJobModal = this.openDeferJobModal.bind(this);
        this.showDeferJobModal = this.showDeferJobModal.bind(this);
        this.onDeferClick = this.onDeferClick.bind(this);
        this.openCloseJobModal = this.openCloseJobModal.bind(this);
        this.showCloseJobModal = this.showCloseJobModal.bind(this);
        this.onUnassignedUpdateClick = this.onUnassignedUpdateClick.bind(this);
    
        this.getAlertMessaging = this.getAlertMessaging.bind(this);
        this.getOpportunities = this.getOpportunities.bind(this);
        this.getProTechnicians = this.getProTechnicians.bind(this);
        this.onOpportunityClick = this.onOpportunityClick.bind(this);
        this.closeOpportunity = this.closeOpportunity.bind(this);

        this.onCancelClick = this.onCancelClick.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
        this.onUpdateClick = this.onUpdateClick.bind(this);

        this.onChangeScheduleDate = this.onChangeScheduleDate.bind(this);
        this.onChangeScheduleTime = this.onChangeScheduleTime.bind(this);
        this.onChangeScheduleDateTime = this.onChangeScheduleDateTime.bind(this);
        this.onChangeTechnician = this.onChangeTechnician.bind(this);
        this.onChangeVerification = this.onChangeVerification.bind(this);
        this.onChangeJobValue = this.onChangeJobValue.bind(this);
        this.onChangeNotes = this.onChangeNotes.bind(this);
        this.onChangeClosedTime = this.onChangeClosedTime.bind(this);
        this.onChangeStatus = this.onChangeStatus.bind(this);

        this.onChangeJobDone = this.onChangeJobDone.bind(this);
        this.onChangeHours = this.onChangeHours.bind(this);
        this.onChangeMinutes = this.onChangeMinutes.bind(this);
        this.onChangeTotalParts = this.onChangeTotalParts.bind(this);
        this.handleChangePart = this.handleChangePart.bind(this);
        this.getHrsAndMins = this.getHrsAndMins.bind(this);

        this.onAddPartClick = this.onAddPartClick.bind(this);
        this.onDeletePartClick = this.onDeletePartClick.bind(this);
        this.onReplaceSystem = this.onReplaceSystem.bind(this);
        this.openSystemModal = this.openSystemModal.bind(this);
        this.showSystemModal = this.showSystemModal.bind(this);

        this.state = {
            alertArgs: {
                queryId: "custom",
                startTime: null,
                endTime: null,
                isActive: true,
                priority: 3,
                organizationId: null,
                isClosed: false
            },
            currentAccount: {
                parentAccountId: ""
            },
            alertList: [],
            alertType: "Active",
            loading: false,
            alertTableLoading: false,
            noCustomer: false,

            currentPartner: {
                users: [
                    {
                        userId: null,
                        firstName: "",
                        lastName: "",
                        email: null,
                        isActive: null,
                        lastLogin: null,
                        roleList: null,
                        roleListId: [],
                        roleListIdStr: null
                    }
                ]
            },
            beginStr: "",
            endStr: "",
            beginUtcStr: "",
            endUtcstr: "",
            oppPanelLoading: false,
            opportunityLoading: false,
            oppTableLoading: false,
            tableViewType: "Scheduled",
            isSelected: -1,
            selectedTechnicianNumber: -1,
            selectedTechnician: jsTechnician,
            scheduledTime: null,
            closedTime: null,
            selectedVerification: "",
            notes: "",
            technicianList: [],
            opportunityList: [],
            scheduledList: [],
            oppAlertList: [],
            currentHome: jsHouse,
            currentOpportunity: jsOpportunity,
            updateOpportunity: jsOpportunity,
            currentOpportunityDetails: jsDetails,
            currentOpportunityCustomer: jsCustomer,
            message: "",
            scheduledDateTime: "",

            jobDone: "",
            timeSpentHrs: "", 
            timeSpentMins: "",
            timeSpentHrsInt: 0,
            timeSpentMinsInt: 0,
            hrsMessage: "",
            minsMessage: "",
            componentList: [],
            oppParts: [{jsComponent}],
            numParts: 0,
            totalParts: 1,
            multiPart: false,
            replacedSystem: false,
            showSystemModal: false,
            inApptDB: false,

            appointmentDB: {
                caseId: 0,
                appointmentDate: null,
                verificationId: "",
                timeToRepair: "",
                useCaseId: "",
                jobValue: "",
                notes: "",
                closed: false,
                componentReplaced: [ jsComponent ]
            },
            alertMessaging: [],
            currentPartnerSTDetails: { betaST: false },
            
            showAlertGraphs: false,
            showAlertDetailsConfirm: false,
            alertDetail: {},
            detailsLoading: false,
            showUpdateJobConfirm: false,
            showCloseJobConfirm: false,
            showDeferJobConfirm: false
        }
    }

    componentDidMount() {
        this._isMounted = true;
        PageView();
        this.getAlertMessaging();
        this.getProTechnicians(this.props.currentPartnerId);
        this.getOpportunities();
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.currentCustomerId !== this.props.currentCustomerId) {
            this.getAlertMessaging();
            this.getOpportunities();
        }
        if (prevProps.currentPartnerId !== this.props.currentPartnerId) {
            this.getProTechnicians(this.props.currentPartnerId);
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    
    async getAlertMessaging() {
        alerttypemessagingservice.getpartnermessaging(this.props.currentPartnerId)
            .then(response => {
                if (this._isMounted) {
                    this.setState({
                        alertMessaging: response
                    })
                }
            })
            .catch(e => {
                console.log(e);
            })
    }

    async getProTechnicians(partnerId) {
        if (!partnerId || partnerId === "-1") return;
        try {
            const response = await PartnerService.getpropartnerdetail(partnerId);
            const partnerUsers = response?.data?.partnerUsers ?? [];
            const technicians = partnerUsers
                .filter(pu => pu.user != null && pu.roles &&
                    pu.roles.some(r => r.toLowerCase() === "technician" || r.toLowerCase() === "employee"))
                .map(pu => ({
                    userId: pu.id,
                    firstName: pu.user?.firstName || "",
                    lastName: pu.user?.lastName || "",
                    email: pu.user?.contactEmail || "",
                    roleList: pu.roles || []
                }));
            if (this._isMounted) {
                this.setState({ technicianList: technicians });
            }
        } catch (e) {
            console.log('getProTechnicians error:', e);
        }
    }

    async getAlerts() {
        //let startTime = performance.now();
        let now = moment();
        let before =  moment(now).add(-24, 'hours'); 
        let nowStr = now.format();
        let beforeStr = before.format();
        let nowUtcStr = now.utc().format();
        let beforeUtcStr = before.utc().format();

        if (this.props.currentCustomerId === -1) {
            this.setState({ noCustomer: true, loading: false, alertTableLoading: false });
        }
        else {
            alerttypemessagingservice.getpartnermessaging(this.props.currentPartnerId)
                .then(response => {
                    if (this._isMounted) {
                        this.setState({
                            alertMessaging: response
                        }, async () => {
                            this.setState(prevState => ({
                                alertArgs: {
                                    ...prevState.alertArgs,
                                    startTime: beforeUtcStr,
                                    endTime: nowUtcStr,
                                    organizationId: this.props.currentCustomerId
                                }
                            }), async () => {
                                await AlertService.getuseralertlist(this.state.alertType, this.state.alertArgs)
                                    .then(response2 => {
                                        if (this._isMounted) {
                                            this.setState({
                                                alertList: response2.data
                                            }, () => {
                                                this.setState({
                                                    loading: false,
                                                    alertTableLoading: false,
                                                    noCustomer: false
                                                });
                                            });
                                        }
                                    })
                                    .catch(e => {
                                        console.log(e);
                                    })
                            });
                        })
                    }
                })
        }
    }

    async reloadTable() {
        await this.getAlerts();
    }

    async reloadOppTable() {
        await this.getOpportunities();
    }

    changeRadio(val) {
        Event("Radio Clicked", "User clicked radio in Current Job", "Radio Clicked");
        let x = val;

        this.setState({
            alertType: x,
            alertList: []
        });

        this.setState(prevState => ({
            alertArgs: {
                ...prevState.alertArgs,
                isActive: x === "Inactive" ? false : true
            }
        }));

        this.setState({ alertTableLoading: true }, async () => {
            await this.getAlerts();
        });
    }

/* begin appt. form functions */

    openSystemModal() {
        this.showSystemModal();
    }

    showSystemModal() {
        this.setState({
            showSystemModal: !this.state.showSystemModal
        }, () => {
            if (this.state.showSystemModal)
                ModalView('replaceSystem');
        });
        window.scrollTo(0, 0);
    }

    onChangeScheduleTime(e) {
        let time = e.target.value;
        let curr = this.state.currentOpportunity.scheduledForStr.split("T");
        let currDate = curr[0];

        let newStr = currDate.concat("T", time);

        this.setState(prevState => ({
            currentOpportunity: {
                ...prevState.currentOpportunity,
                scheduledForTimeStr: newStr,
                scheduledForStr: newStr
            },
            currentOpportunityDetails: {
                ...prevState.currentOpportunityDetails,
                scheduledFor: newStr
            }
        }));
    }

    onChangeScheduleDateTime(e) {
        let str = moment(e).format();
        let newStr = str.replace("Z", "");
        let dt = moment(e).toDate();
        this.setState(prevState => ({
            currentOpportunity: {
                ...prevState.currentOpportunity,
                scheduledForTimeStr: newStr,
                scheduledForStr: newStr
            },
            currentOpportunityDetails: {
                ...prevState.currentOpportunityDetails,
                scheduledFor: newStr
            },
            appointmentDB: {
                ...prevState.appointmentDB,
                appointmentDate: dt
            },
            scheduledDateTime: dt
        }));
    }

    onChangeClosedTime(e) {
        let time = e.target.value;

        this.setState(prevState => ({
            currentOpportunity: {
                ...prevState.currentOpportunity,
                closedTimeStr: time,
                closedOnStr: time
            }
        }));
    }

    onChangeStatus(e) {
        let status = e.target.value;

        this.setState(prevState => ({
            currentOpportunity: {
                ...prevState.currentOpportunity,
                status: status
            },
            currentOpportunityDetails: {
                ...prevState.currentOpportunityDetails,
                status: status
            }
        }));
    }

/* START NEW QUESTIONS */

    onChangeJobDone(e) {
        let jobDone = e.target.value;
        let jobInt = parseInt(jobDone);
        let multiPart = false;
        let replacedSystem = false;
        let totalParts = 1;
        //let numParts = 0;
        let jobComponent = jsComponent;
        jobComponent.caseId = this.state.appointmentDB.caseId;
        let parts = [jobComponent];

        if (jobInt === 2 || jobInt === 4) {
            multiPart = true;
            totalParts = 2;
            //numParts = 1;
            parts[1] = jobComponent;
        }
        else if (jobInt > 4)
            replacedSystem = true;

        if (this.state.jobDone !== jobDone) {
            this.setState(prevState => ({
                jobDone: jobInt,
                oppParts: parts,
                numParts: 0, //should this be set equal to numParts variable? commented out to get rid of console warning
                totalParts: totalParts,
                multiPart: multiPart,
                replacedSystem: replacedSystem,
                appointmentDB: {
                    ...prevState.appointmentDB,
                    useCaseId: jobInt
                }
            }));
        }
        else 
            this.setState({ jobDone: jobDone });
    }

    onChangeHours(e) {
        let hrs = e.target.value;
        let hrsInt = parseInt(hrs);
        if (hrsInt < 0 || hrsInt > 24) {
            this.setState({ timeSpentHrs: hrs, timeSpentHrsInt: hrsInt, hrsMessage: "Hours must be between 0-24" });
        }
        else {
            let repairTime = hrsInt * 60 + this.state.timeSpentMinsInt;
            this.setState(prevState => ({
                timeSpentHrs: hrs,
                timeSpentHrsInt: hrsInt,
                hrsMessage: "",
                appointmentDB: {
                    ...prevState.appointmentDB,
                    timeToRepair: repairTime
                }
            }));
        }
    }

    onChangeMinutes(e) {
        let mins = e.target.value;
        let minsInt = parseInt(mins);
        if (mins < 0 || mins > 60) {
            this.setState({ timeSpentMins: mins, timeSpentMinsInt: minsInt, minsMessage: "Minutes must be between 0-60" });
        }
        else {
            let repairTime = this.state.timeSpentHrsInt * 60 + minsInt;
            this.setState(prevState => ({
                timeSpentMins: mins,
                timeSpentMinsInt: minsInt,
                minsMessage: "",
                appointmentDB: {
                    ...prevState.appointmentDB,
                    timeToRepair: repairTime
                }
            }));
        }
    }

    handleChangePart(newPart, index) {
        let parts = this.state.oppParts;
        parts[index] = newPart;
        this.setState(prevState => ({
            oppParts: parts,
            appointmentDB: {
                ...prevState.appointmentDB,
                componentReplaced: parts
            }
        }));
    }

    onChangeTotalParts(e) {
        let currentNum = this.state.totalParts;
        let parts = this.state.oppParts;
        let numParts = e.target.value;
        let num = parseInt(numParts);

        if (num !== currentNum) {
            let i = currentNum - 1;
            if (num > currentNum) {
                while (i < num) {
                    parts[i] = jsComponent;
                    i++;
                }
            }
            else {
                i++;
                while (i > num) {
                    parts.pop();
                    i--;
                }
            }
        }

        this.setState({ totalParts: num, numParts: num - 1, oppParts: parts });
    }

    onAddPartClick() {
        Event("Add Part Clicked", "Users clicked add part in Current Job", "Add Part Clicked");
        this.setState({ numParts: this.state.numParts + 1 }, () => {
            let parts = this.state.oppParts;
            parts[this.state.numParts] = jsComponent;
            this.setState({ oppParts: parts });
        });
    }

    onDeletePartClick() {
        Event("Delete Part Clicked", "Users clicked delete part in Current Job", "Delete Part Clicked");
        let parts = this.state.oppParts;
        parts.pop();
        this.setState({ numParts: this.state.numParts - 1, oppParts: parts });
    }

/* END NEW QUESTIONS */
    
    onReplaceSystem() {
        Event("System Replaced", "User replaced system in Current Job", "System Replaced");
        this.showSystemModal();
        this.closeOpportunity();
    }

    onCancelClick() {
        Event("Cancel Opportunity Clicked", "User clicked button to cancel changes to opportunity", "Cancel Opportunity Changes Clicked");
        this.setState({ currentOpportunity: jsOpportunity, currentOpportunityDetails: jsDetails, message: "Changes canceled!", scheduledDateTime: "", jobDone: "", timeSpentHrs: "", timeSpentMins: "", timeSpentHrsInt: 0, timeSpentMinsInt: 0, componentList: [], oppParts: [{ jsComponent }], numParts: 0, multiPart: false, replacedSystem: false }, () => {
            if (this.state.isSelected !== -1 && this.state.scheduledList !== null && this.state.scheduledList !== undefined && this.state.scheduledList.length)
                this.setState({ currentOpportunity: this.state.opportunityList[this.state.isSelected] }, () => {
                    this.setState({ currentOpportunityDetails: this.state.currentOpportunity.details });
                    if (this.state.currentOpportunity.scheduledForTimeStr !== null && this.state.currentOpportunity.scheduledForTimeStr !== "" && this.state.currentOpportunity.scheduledForTimeStr !== undefined) {
                        let dt = new Date(this.state.currentOpportunity.scheduledForTimeStr);
                        this.setState({ scheduledDateTime: dt });
                    }
                })
        });

        setTimeout(() => {
            this.setState({
                message: ""
            });
        }, 3000);
    }

    onCloseClick() {
        let errorMsg = "";
        let errorFields = [];

        if (this.state.currentOpportunity.scheduledForTimeStr === "")
            errorFields.push("Scheduled Time");
        if (this.state.currentOpportunity.assignedToId === "" || this.state.currentOpportunity.assignedToId === null)
            errorFields.push("Technician");
        if (this.state.currentOpportunity.isFalsePositive === "")
            errorFields.push("Verification");

        if (this.state.appointmentDB.useCaseId === "" || this.state.appointmentDB.useCaseId === 0)
            errorFields.push("Action Taken");
        else if (this.state.appointmentDB.useCaseId === 1 || this.state.appointmentDB.useCaseId === 3) {
            if (this.state.oppParts[0].componentId === -1 || (this.state.oppParts[0].componentId === 13 && (this.state.oppParts[0].other === "None" || this.state.oppParts[0].other === "")))
                errorFields.push("Part Type");
            if (this.state.oppParts[0].oem === "")
                errorFields.push("OEM Selection");
            if (this.state.timeSpentHrs === "" || this.state.timeSpentMins === "")
                errorFields.push("Time Spent (Hours and Minutes)");
            else if (this.state.hrsMessage !== "" || this.state.minsMessage !== "")
                errorFields.push("Valid Time Spent Selection")
        }
        else if (this.state.appointmentDB.useCaseId === 2 || this.state.appointmentDB.useCaseId === 4) {
            let partsError = false;
            this.state.oppParts.forEach(part => {
                if (part.componentId === -1 || part.oem === "" || (part.componentId === 13 && (part.other === "None" || part.other === "")))
                    partsError = true;
            }); 
            if (partsError)
                errorFields.push("Each Part's Type and OEM Selection")
            if (this.state.timeSpentHrs === "" || this.state.timeSpentMins === "")
                errorFields.push("Time Spent (Hours and Minutes)");
            else if (this.state.hrsMessage !== "" || this.state.minsMessage !== "")
                errorFields.push("Valid Time Spent Selection")
        }
        else if (this.state.appointmentDB.useCaseId > 4) {
            if (this.state.timeSpentHrs === "" || this.state.timeSpentMins === "")
                errorFields.push("Time Spent (Hours and Minutes)");
            else if (this.state.hrsMessage !== "" || this.state.minsMessage !== "")
                errorFields.push("Valid Time Spent Selection")
        }

        if (this.state.currentOpportunityDetails.impactEstimate === "" || this.state.currentOpportunityDetails.impactEstimate === null)
            errorFields.push("Job Value");

        errorMsg = errorFields.join(", ");

        if (errorMsg !== "") {
            let txt = " is ";
            if (errorFields.length > 1) txt = " are ";
            this.setState({ message: errorMsg + txt + "required to close opportunity." });

            setTimeout(() => {
                this.setState({
                    message: ""
                });
            }, 3000);
        }
        else {
            this.setState(prevState => ({
                currentOpportunityDetails: {
                    ...prevState.currentOpportunityDetails,
                    status: "Closed"
                },
                appointmentDB: {
                    ...prevState.appointmentDB,
                    closed: true
                }
            }), () => {
                    if (this.state.replacedSystem) {
                        this.openSystemModal();
                    }
                    else {
                        this.closeOpportunity();
                    }
            });
        }
    }

    async closeOpportunity() {
        Event("Oportunity Closed", "User closed opportunity in Current Job", "Opportunity Closed");
        this.setState({ opportunityLoading: true });
        await ScheduleService.updateopportunity(this.state.currentOpportunity.scheduledForTimeStr, this.state.currentOpportunityDetails.assignedToId, this.state.currentOpportunityDetails)
            .then(response => {
                if (response.data === true) {
                    this.setState({
                        message: ""
                    }, async () => {
                        if (this.state.inApptDB)
                            await appointmentService.updateappointmentdb(this.state.appointmentDB)
                                .then(response3 => {
                                    if (response3 !== null) {  
                                        this.setState({ message: "Appointment has been successfully updated in the database!" }, async () => {
                                            let message = "";

                                            if (this.state.appointmentDB.useCaseId > 2) {
                                                await AssetService.updateassetclasses(parseInt(this.state.currentOpportunity.assetId), this.state.appointmentDB.useCaseId).then(response5 => {

                                                    if (response5.statusCode === 200) {
                                                        message = "Successfully updated Asset classes!";
                                                    }
                                                    else {
                                                        message = "Failed to update Asset classes!";
                                                    }

                                                    this.setState({
                                                        statusMessage: message
                                                    });
                                                });
                                            }
                                        });
                                    }
                                })
                                .catch(e => {
                                    console.log(e);
                                });
                        else
                            await appointmentService.addappointmentdb(this.state.appointmentDB)
                                .then(response4 => {
                                    if (response4 !== null && response4.caseId !== null) { 
                                        this.setState({ message: "Appointment has been successfully updated in the database!" }, async () => {
                                            let message = "";

                                            if (this.state.appointmentDB.useCaseId > 2) {
                                                await AssetService.updateassetclasses(parseInt(this.state.currentOpportunity.assetId), this.state.appointmentDB.useCaseId).then(response6 => {

                                                    if (response6.statusCode === 200) {
                                                        message = "Successfully updated Asset classes!";
                                                    }
                                                    else {
                                                        message = "Failed to update Asset classes!";
                                                    }

                                                    this.setState({
                                                        statusMessage: message
                                                    });
                                                });
                                            }
                                        });
                                    }
                                })
                                .catch(e => {
                                    console.log(e);
                                });

                        if (this.state.currentOpportunity.sourceId !== null && this.state.currentOpportunity.sourceId !== undefined) 
                            await AlertService.closealert(parseInt(this.state.currentOpportunity.sourceId))
                                .then(response2 => {
                                    if (response2.statusCode === 200) {
                                        this.setState({
                                            message: "The opportunity and associated alert were closed successfully!"
                                        });

                                        Event("Close Opportunity Clicked", "User clicked close opportunity button", "Close Opportunity Clicked");

                                        this.reloadOppTable();
                                    }
                                });
                        else
                            this.setState({ message: "Failed to close the associated alert for the opportunity!", opportunityLoading: false });

                            setTimeout(() => {
                                this.setState({
                                    message: ""
                                });
                            }, 3000);
                    });
                }
                else {
                    this.setState({
                        message: "Failed to close the opportunity!",
                        opportunityLoading: false
                    });
                }

                setTimeout(() => {
                    this.setState({
                        message: ""
                    });
                }, 3000);
            })
            .catch(e => {
                console.log(e);
            });
    }

    /* end appt. form functions */

    async onOpportunityClick(index) {
        let x = index;
        Event("Opportunity Clicked", "User clicked on an opportunity in the table", "Opportunity Clicked");

        if (this.state.isSelected === index) {
            this.setState({
                currentOpportunity: jsOpportunity,
                currentOpportunityDetails: jsDetails,
                currentOpportunityCustomer: jsCustomer,
                currentHome: jsHouse,
                selectedTechnician: jsTechnician,
                scheduleDetails: { ...jsScheduleDetails },
                isSelected: -1,
                jobDone: "",
                timeSpentHrs: "",
                timeSpentMins: "",
                timeSpentHrsInt: 0,
                timeSpentMinsInt: 0,
                componentList: [],
                oppParts: [{ jsComponent }],
                numParts: 0,
                multiPart: false,
                replacedSystem: false
            });
        }
        else {
            this.setState({
                currentOpportunity: jsOpportunity,
                currentOpportunityDetails: jsDetails,
                currentOpportunityCustomer: jsCustomer,
                currentHome: jsHouse,
                selectedTechnician: jsTechnician,
                scheduleDetails: { ...jsScheduleDetails },
                opportunityLoading: true,
                isSelected: index,
                jobDone: "",
                timeSpentHrs: "",
                timeSpentMins: "",
                timeSpentHrsInt: 0,
                timeSpentMinsInt: 0,
                componentList: [],
                oppParts: [{ jsComponent }],
                numParts: 0,
                multiPart: false,
                replacedSystem: false
            }, () => {
                this.setState({
                    currentOpportunity: this.state.opportunityList[x],
                    updateOpportunity: this.state.opportunityList[x]
                }, async () => {
                    if (this._isMounted) {
                        const opp = this.state.opportunityList[x];
                        let alertList = [];
                        alertList.push(opp.alert);

                        // ── Fetch fully-enriched opportunity details ─────────────────
                        // Calling getopportunitydetails runs EnrichOpportunityDetailWithTechAssignment
                        // on the backend, which overlays AssignedToId / AssignedToName from our
                        // local OpportunityTechAssignment table — the source of truth for RIS
                        // tech assignments. Without this, the Update Job modal and "Assigned To"
                        // field show blank / stale TwinThread data.
                        let enrichedDetails = opp.details; // safe fallback
                        try {
                            const detailsResponse = await ScheduleService.getopportunitydetails(opp.caseId);
                            if (detailsResponse?.data) enrichedDetails = detailsResponse.data;
                        } catch (e) {
                            console.log('getopportunitydetails failed, using list payload details:', e);
                        }

                        // ── Resolve assigned technician ──────────────────────────────
                        // Prefer the enriched assignedToId (from OpportunityTechAssignment) over
                        // the raw TT value. Match against our RIS technicianList to get proper
                        // firstName / lastName split for the modal. Same logic as ScheduleRepairs.
                        const assignedId   = enrichedDetails?.assignedToId   || opp?.assignedToId;
                        const assignedName = enrichedDetails?.assignedToName || opp?.assignedToName || '';
                        const matchedTech  = assignedId
                            ? this.state.technicianList?.find(t => t.userId == assignedId)
                            : null;
                        const nameParts = assignedName.trim().split(/\s+/);
                        const technicianDetails = matchedTech
                            ? { ...matchedTech }
                            : {
                                userId: assignedId || null,
                                firstName: nameParts[0] || "",
                                lastName: nameParts.slice(1).join(' ') || ""
                            };

                        // ── Build initial scheduleDetails ────────────────────────────
                        // Mirrors buildInitialScheduleDetails() from ScheduleRepairs so the
                        // Job Details panel renders correctly before any ST overlay.
                        const techDisplay = matchedTech
                            ? `${matchedTech.lastName || ''}, ${matchedTech.firstName || ''}`
                            : assignedName;
                        const scheduledDate =
                            (opp?.scheduledForStr && opp.scheduledForStr !== '' && opp.scheduledForStr !== '0001-01-01T00:00:00Z')
                                ? opp.scheduledForStr
                                : (opp?.scheduledForTimeStr || enrichedDetails?.scheduledFor || '');
                        const initialScheduleDetails = {
                            ...jsScheduleDetails,
                            scheduledDate,
                            technician: techDisplay,
                            jobStatus:  opp?.status   || enrichedDetails?.status || '',
                            jobvalue:   opp?.impact   || (enrichedDetails?.impactEstimate != null ? String(enrichedDetails.impactEstimate) : ''),
                            jobNotes:   opp?.comment  || enrichedDetails?.comment || ''
                        };

                        this.setState({
                            // Mirror the enriched assignment data back onto currentOpportunity so
                            // renderExpandContent ("Assigned To") and UpdateJobModal both read the
                            // correct assignedToId / assignedToName instead of the stale list-payload.
                            currentOpportunity: {
                                ...this.state.opportunityList[x],
                                assignedToId:   assignedId   || opp?.assignedToId   || '',
                                assignedToName: assignedName || opp?.assignedToName || ''
                            },
                            currentOpportunityDetails: enrichedDetails,
                            selectedTechnician: technicianDetails,
                            alertList: alertList,
                            scheduleDetails: initialScheduleDetails
                        }, async () => {
                            const orgId = this.state.currentOpportunityDetails?.organizationId;
                            if (orgId !== null && orgId !== undefined) {
                                // Detect pro-only customer: TT orgId is 1 (top-level org, no real hierarchy)
                                // or the partner ID is a RIS GUID (non-integer).
                                const isProOrg = parseInt(orgId) <= 1 || isNaN(parseInt(orgId))
                                    || isNaN(parseInt(this.props.currentPartnerId));

                                if (isProOrg) {
                                    // ── Pro customer path ────────────────────────────────────
                                    // Use enriched proCustomerName / proCustomerId from backend
                                    // (set by EnrichOpportunitiesWithProCustomer &
                                    //  EnrichAlertsWithProCustomerAsync). Look up full customer
                                    // record from props.customers for phone/address data.
                                    const proCustomerId = opp?.proCustomerId || opp?.alert?.proCustomerId;
                                    const proCustomerName = opp?.proCustomerName || opp?.alert?.proCustomerName || '';
                                    const nameParts = proCustomerName.split(', ');

                                    const customers = this.props.customers || [];
                                    const matchedCustomer = proCustomerId
                                        ? customers.find(c =>
                                            c.id === proCustomerId ||
                                            (c.id && proCustomerId && c.id.endsWith(proCustomerId.slice(-50))))
                                        : customers.find(c =>
                                            String(c.organizationId) === String(this.props.currentCustomerId));

                                    const customer = matchedCustomer || {};
                                    const loc = customer?.deviceLocations?.[0] || {};

                                    this.setState({
                                        currentOpportunityCustomer: {
                                            firstName: nameParts[1] || '',
                                            lastName: nameParts[0] || '',
                                            phone: customer?.phoneNumber || '',
                                            email: customer?.email || '',
                                            accountId: proCustomerId || this.props.currentCustomerId,
                                            parentAccountId: this.props.currentPartnerId
                                        },
                                        currentHome: {
                                            ...jsHouse,
                                            address: loc.address || '',
                                            city: loc.city || '',
                                            state: loc.state || '',
                                            zip: loc.zipCode || loc.zip || ''
                                        }
                                    });

                                    if (this.state.currentOpportunityDetails.scheduledFor) {
                                        try {
                                            const match = this.state.currentOpportunityDetails.scheduledFor.match(/\d+/);
                                            if (match) this.setState({ scheduledDateTime: new Date(match[0] * 1) });
                                        } catch (_) {}
                                    }
                                } else {
                                    // ── Legacy TT path ──────────────────────────────────────
                                    await AccountService.get(orgId, false)
                                        .then(response2 => {
                                            if (this._isMounted) {
                                                this.setState({
                                                    currentOpportunityCustomer: response2.data
                                                }, async () => {
                                                    await AccountService.getpartnerinfo(this.state.currentOpportunityCustomer.parentAccountId, true)
                                                        .then(response3 => {
                                                            if (this._isMounted) {
                                                                this.setState({ currentPartner: response3.data }, () => {
                                                                    this.setState({ technicianList: this.state.currentPartner.users.filter(user => user.roleList.includes("Technician")) });
                                                                });
                                                            }
                                                        })
                                                        .catch(e => { console.log(e); });
                                                });
                                            }
                                        })
                                        .catch(e => { console.log(e); });

                                    await HomeService.get(orgId, this.state.currentOpportunityDetails.parentAccountId)
                                        .then(response4 => {
                                            if (this._isMounted) {
                                                this.setState({ currentHome: response4.data[0] }, () => {
                                                    if (this.state.currentOpportunityDetails.scheduledFor) {
                                                        let dt = new Date(this.state.currentOpportunityDetails.scheduledFor.match(/\d+/)[0] * 1);
                                                        this.setState({ scheduledDateTime: dt });
                                                    }
                                                });
                                            }
                                        });
                                }

                                // ── Shared: ST details, alert asset, HVAC components ────────
                                // Only call ServiceTitan when:
                                //   1. This partner has a ST integration (hasServiceTitan prop)
                                //   2. This is NOT a pro-only customer (pro customers have no ST record)
                                //   3. The case is alert-derived ("A" prefix in case number)
                                // For manually created jobs, non-ST partners, or pro customers skip
                                // entirely — same pattern as ScheduleRepairs.
                                if (this.props.hasServiceTitan && !isProOrg && opp.number?.includes('A')) {
                                    await ServiceTitanService.getScheduleDetails(opp.caseId)
                                        .then(response7 => {
                                            if (this._isMounted) {
                                                const responseDetails = response7.data;
                                                // Spread the already-populated scheduleDetails so ST only
                                                // overlays fields it actually provides — don't reset to defaults.
                                                let details = { ...this.state.scheduleDetails };

                                                if (responseDetails?.leadId != null && responseDetails?.leadId !== '') {
                                                    details.stID = responseDetails.leadId;
                                                }
                                                if (responseDetails?.opportunitieId != null && responseDetails?.opportunitieId !== '') {
                                                    details.lwJobID = responseDetails.opportunitieId;
                                                }
                                                if (responseDetails?.scheduledDate != null && responseDetails?.scheduledDate !== '' && responseDetails?.scheduledDate !== '0001-01-01T00:00:00') {
                                                    details.scheduledDate = responseDetails.scheduledDate;
                                                }
                                                if (responseDetails?.technician != null && responseDetails?.technician !== '') {
                                                    details.technician = responseDetails.technician;
                                                }
                                                if (responseDetails?.jobStatus != null && responseDetails?.jobStatus !== '') {
                                                    details.jobStatus = responseDetails.jobStatus;
                                                }
                                                if (responseDetails?.jobvalue != null && responseDetails?.jobvalue !== '') {
                                                    details.jobvalue = responseDetails.jobvalue;
                                                }
                                                if (responseDetails?.jobNotes != null && responseDetails?.jobNotes !== '') {
                                                    details.jobNotes = responseDetails.jobNotes;
                                                }
                                                if (responseDetails?.jobValue?.includes('||')) {
                                                    const parts = responseDetails.jobValue.split('||');
                                                    details.invoiceTotal = parts[1] ?? '00';
                                                }

                                                this.setState({ scheduleDetails: details, expandLoading: false });
                                            }
                                        }).catch(e => {
                                            this.setState({ expandLoading: false });
                                            console.log(e);
                                        });
                                } else {
                                    // Non-alert / manual job — no ST record exists, just clear the loader.
                                    this.setState({ expandLoading: false });
                                }

                                await AlertService.getalertasset(opp.alert)
                                    .then(response6 => {
                                        this.setState({ currentAsset: response6.data, detailsLoading: false });
                                    })
                                    .catch(e => { console.log(e); });

                                await hvaccomponentService.gethvaccomponents(opp.assetType)
                                    .then(response5 => {
                                        if (this._isMounted) {
                                            this.setState({ componentList: response5, opportunityLoading: false });
                                        }
                                    });
                            }
                            else {
                                this.setState({
                                    opportunityLoading: false,
                                    message: "Invalid appointment information."
                                });
                                setTimeout(() => { this.setState({ message: "" }); }, 3000);
                            }
                        });
                    }
                });
            });
        }
    }

    async getOpportunities() {
        //let startTime = performance.now();
        let now = moment();
        let nowStr = moment(now).add(24, 'hours').format();
        let beforeStr =moment(now).add(-24, 'hours').format();
        
        this.setState({
            beginStr: beforeStr,
            endStr: nowStr,
            oppPanelLoading: true,
            isSelected: -1,
            currentOpportunity: jsOpportunity,
            currentOpportunityDetails: jsDetails,
            currentOpportunityCustomer: jsCustomer,
            tableViewType: this.state.tableViewType
        }, async () => {
            await ScheduleService.getuseropportunities(this.state.beginStr, this.state.endStr, this.props.currentCustomerId)
                .then(response3 => {
                    if (this._isMounted) {
                        this.setState({
                            opportunityList: response3.data,
                            selectedTechnician: jsTechnician,
                            oppPanelLoading: false,
                            opportunityLoading: false,
                            loading: false
                        }, () => {
                            this.setState({
                                scheduledList: this.state.opportunityList["Scheduled"],
                                opportunityList: this.state.opportunityList["Scheduled"]
                            });

                        });
                    }
                })
                    .catch(e => {
                        console.log(e);
                        this.setState({ loading: false, oppPanelLoading: false, message: "caught in getOpportunities()" });

                        setTimeout(() => {
                            this.setState({
                                message: ""
                            });
                        }, 3000);
                    });
        });
    }
    
    //update
    openUpdateJobModal(job) {
        this.setState({ 
            updateOpportunity: this.state.currentOpportunity, 
            updateDetails: this.state.currentOpportunityDetails 
        }, () => {
            this.showUpdateJobModal();
        });
    }

    showUpdateJobModal() {
        this.setState({
            showUpdateJobConfirm: !this.state.showUpdateJobConfirm
        }, () => {
            if (this.state.showUpdateJobConfirm) {
                ModalView("updateJob");
            }
        });
    }

    onUnassignedUpdateClick() {
        Event("Unassigned Update Clicked", "User clicked unassigned update in Schedule Repairs", "Unassigned Update Clicked");
        this.setState({
            showUnassignedTechUpdateConfirm: false
        }, async () => {
            let dateStr = this.state.currentOpportunity.scheduledForTimeStr;
            if (this.state.scheduledDateTime != null && dateStr === "" || dateStr === null) {
                dateStr = moment(this.state.scheduledDateTime).format();
            }

            await ScheduleService.updateopportunity(dateStr, -1, this.state.currentOpportunityDetails)
                .then(response => {
                    if (this._isMounted) {
                        if (response.data === true) {
                            this.setState({
                                message: "The job was updated successfully!",
                                showMessage: true,
                                expandLoading: false
                            });
                        }
                        else {
                            this.setState({
                                message: "Failed to update the job!",
                                showMessage: true,
                                expandLoading: false
                            });
                        }

                        setTimeout(() => {
                            this.setState({
                                message: "",
                                showMessage: false
                            });
                        }, 3000);
                    }
                })
                .catch(e => {
                    console.log(e);
                });
        });
    }

    async onUpdateClick() {
        Event("Update Job Clicked", "User clicked update in Schedule Repairs", "Update Job Clicked");
        let errorMsg = "";
        let job = this.state.currentOpportunity;
        if ((this.state.tableViewType === "Closed" || this.state.tableViewType === "Unscheduled") && this.state.scheduledDateTime != null && job.scheduledForTimeStr === "" || job.scheduledForTimeStr === null) {
            job.scheduledForTimeStr = moment(this.state.scheduledDateTime).format();
        }

        if (job.scheduledForTimeStr === "" || job.scheduledForTimeStr === null) {
            errorMsg = "Scheduled time is required to update.";
        }

        if (errorMsg !== "") {
            this.setState({ message: errorMsg, showMessage: true });

            setTimeout(() => {
                this.setState({
                    message: "",
                    showMessage: false
                });
            }, 3000);
        }
        else {
            let myJsDetail = this.state.currentOpportunityDetails;
            myJsDetail.houseAssetId = this.state.currentHome !== undefined ? this.state.currentHome.assetId.toString() : null;
            if (this.state.currentOpportunityCustomer !== undefined) {
                myJsDetail.customerOrgId = this.state.currentOpportunityCustomer.accountId;
                myJsDetail.customerFirstName = this.state.currentOpportunityCustomer.firstName;
                myJsDetail.customerLastName = this.state.currentOpportunityCustomer.lastName;
            }

            if (this.state.isJobClose) {
                myJsDetail.status = "Closed"
            }

            this.setState({
                currentOpportunity: job,
                currentOpportunityDetails: myJsDetail,
                expandLoading: true,
                opportunityLoading: true,
                showUpdateJobConfirm: false
            }, async () => {
                if ((job.assignedToId === "" || job.assignedToId === null) && this.state.currentPartnerSTDetails?.betaST) {
                    this.onUnassignedUpdateClick()
                }
                else if (job.assignedToId === "" || job.assignedToId === null) {
                    this.setState({
                        showUnassignedTechUpdateConfirm: true,
                        modalTitle: "Unassigned Technician",
                        modalMessage: "You are about to Update a Job without a Technician are you sure you'd like to continue?"
                    });
                }
                else {
                    await ScheduleService.updateopportunity(job.scheduledForTimeStr, job.assignedToId, myJsDetail)
                        .then(response => {
                            if (this._isMounted) {
                                if (response.data === true) {
                                    this.setState({
                                            message: ""
                                        },
                                        async () => {
                                            if (this.state.isJobClose) {
                                                await this.reclassRepairedAsset();
                                                if (this.state.currentOpportunityDetails !== null && this.state.currentOpportunityDetails.number !== null && this.state.currentOpportunityDetails.number.includes("A")) {
                                                    await this.getAlerts();
                                                }
                                                else {
                                                    this.setState({ message: "The opportunity was successfully closed! No associated alert to close found.", showMessage: true, opportunityLoading: false });

                                                    setTimeout(() => {
                                                        this.setState({
                                                            message: "",
                                                            showMessage: false
                                                        });
                                                    }, 3000);
                                                }
                                                await this.reloadOppTable();
                                            }
                                        });
                                    let userMessage = "";
                                    let showuserMessage = false;

                                    if (!this.state.isJobClose) {
                                        userMessage = "The job was updated successfully!";
                                        showuserMessage = true;
                                    }

                                    this.setState({
                                        message: userMessage,
                                        showMessage: showuserMessage,
                                        expandLoading: false
                                    }, () => {
                                        this.reloadOppTable();
                                    });

                                    setTimeout(() => {
                                        this.setState({
                                            message: "",
                                            showMessage: false
                                        });
                                    }, 3000);
                                }
                            }
                        })
                        .catch(e => {
                            console.log(e);
                        });
                }
            });
        }
    }

    //defer
    openDeferJobModal() {
        this.setState({ modalTitle: "Defer Job", modalMessage: "You are about to defer this job. Are you sure?" }, () => {
            this.showDeferJobModal();
        });
    }

    showDeferJobModal() {
        this.setState({ showDeferJobConfirm: !this.state.showDeferJobConfirm }, () => {
            if (this.state.showDeferJobConfirm) {
                ModalView("deferJob");
            }
        });
    }

    onDeferClick() {
        Event("Defer Clicked", "User clicked to defer job in Schedule Repairs", "Defer Clicked");
        this.setState({ 
            showDeferJobConfirm: false, 
            opportunityLoading: true 
        }, async () => {
            await ScheduleService.updateopportunitystatus(this.state.currentOpportunity.caseId, "Deferred")
                .then(response => {
                    if (response.data === true) {
                        this.setState({
                            message: "The job was deferred successfully",
                            showMessage: true
                        });

                        this.reloadOppTable();
                    }
                    else {
                        this.setState({
                            message: "Failed to defer the job",
                            showMessage: true
                        });
                    }

                    setTimeout(() => {
                        this.setState({
                            message: "",
                            showMessage: false
                        });
                    }, 3000);
                })
                .catch(e => {
                    console.log(e);
                });
        });
    }
    
    //close

    openCloseJobModal() {
        this.setState({ modalTitle: "Close Job", modalMessage: "You are about to close this job. Are you sure?" }, () => {
            this.showDeferJobModal();
        });
    }

    showCloseJobModal() {
        this.setState({ showCloseJobConfirm: !this.state.showCloseJobConfirm }, () => {
            if (this.state.showCloseJobConfirm) {
                ModalView("closeJob");
            }
        });
    }

    //details

    openAlertDetailsModal() {
        this.setState({
            showAlertDetailsConfirm: !this.state.showAlertDetailsConfirm
        }, () => {
            if (this.state.showAlertDetailsConfirm) {
                ModalView("alertDetails");
            }
        });
    }

    async onDetailsClick() {
        this.openAlertDetailsModal();
        let alertId = this.state.currentOpportunityDetails.number.slice(1);
        this.setState({ detailsLoading: true }, async () => {
            await AlertService.getalertdetails(alertId)
                .then(response => {
                    if (this._isMounted)
                        this.setState({ alertDetail: response?.data, detailsLoading: true }, async () => {
                            let alert = response?.data?.alert.length > 0 ? response?.data?.alert[0] : {};
                            await AlertService.getalertasset(alert)
                                .then(response2 => {
                                    this.setState({ currentAsset: response2?.data, detailsLoading: false });
                                })
                                .catch(e => {
                                    console.log(e);
                                });
                        });
                })
                .catch(e => {
                    console.log(e);
                });
        });
    }

    //update

    onChangeScheduleDate(dateStr) {
        let dt = new Date(dateStr);
        this.setState(prevState => ({
            scheduledDateTime: dt,
            currentOpportunity: {
                ...prevState.currentOpportunity,
                scheduledForTimeStr: dateStr,
                scheduledForStr: dateStr
            },
            currentOpportunityDetails: {
                ...prevState.currentOpportunityDetails,
                scheduledFor: dateStr,

            }
        }));
    }

    onChangeTechnician(selectedTech) {
        let name = selectedTech.firstName + " " + selectedTech.lastName;
        this.setState(prevState => ({
            selectedTechnician: selectedTech,
            currentOpportunity: {
                ...prevState.currentOpportunity,
                assignedToId: selectedTech.userId,
                assignedToName: name
            },
            currentOpportunityDetails: {
                ...prevState.currentOpportunityDetails,
                assignedToId: selectedTech.userId,
                assignedToName: name
            }
        }));
    }

    onChangeVerification(selectedVer) {
        const verify = (selectedVer.value === "true");

        this.setState(prevState => ({
            currentOpportunity: {
                ...prevState.currentOpportunity,
                isFalsePositive: verify
            },
            currentOpportunityDetails: {
                ...prevState.currentOpportunityDetails,
                isFalsePositive: verify
            }
        }));
    }

    onChangeJobValue(impact) {
        this.setState(prevState => ({
            currentOpportunity: {
                ...prevState.currentOpportunity,
                impact: parseInt(impact, 10),
                impactEstimate: parseInt(impact, 10)
            },
            currentOpportunityDetails: {
                ...prevState.currentOpportunityDetails,
                impactEstimate: parseInt(impact, 10),
                impactType: "Money",
                impactTypeId: 1
            }
        }));
    }

    onChangeNotes(notes) {
        this.setState(prevState => ({
            currentOpportunity: {
                ...prevState.currentOpportunity,
                comment: notes
            },
            currentOpportunityDetails: {
                ...prevState.currentOpportunityDetails,
                comment: notes
            }
        }));
    }

    onCancelUpdateClick() {
        Event("Cancel Update Clicked", "User clicked cancel update in Schedule Repairs", "Cancel Update Clicked");
        this.setState({ currentOpportunity: this.state.updateOpportunity, currentOpportunityDetails: this.state.updateDetails, isJobClose: false });
    }
    
    //general

    onAlertCancelClick() {
        this.setState({ alertDetail: null });
    };

    getHrsAndMins(totalMins) {
        let hrs = 0;
        let mins = 0;

        hrs = Math.floor(totalMins / 60);
        mins = totalMins - hrs * 60;

        this.setState({ timeSpentHrs: hrs.toString(), timeSpentHrsInt: hrs, timeSpentMins: mins.toString(), timeSpentMinsInt: mins });
    }

    getCurrOppDate(str) {
        let curr = str.split("T");
        let date = curr[0];

        return (date);
    }

    getCurrOppTime(str) {
        let curr = str.split("T");
        let time = curr[1];

        return (time);
    }

    getDate(str) {
        let date = "";
        if (moment(str).isValid()) {
            return moment(str).format("l h:mm A");
        }
        return (date);
    }

    convertDate(str) {
        let d = new Date(str);

        return d;
    }

    renderTimeMessage() {
        if (this.state.hrsMessage !== "" && this.state.minsMessage !== "") {
            return (
                <div className="col-12 centered"><small style={{ color: 'red' }}>{this.state.hrsMessage + " and " + this.state.minsMessage}</small></div>
            );
        }
        else 
            return (
                <div className="col-12 centered"><small style={{ color: 'red' }}>{this.state.hrsMessage + this.state.minsMessage}</small></div>
                );
    }

    renderJobQuestions(jobDone) {
        let jobQuestions = null;
        let jobInt = parseInt(jobDone); // UseCaseId

        let timeMessage = this.state.hrsMessage !== "" || this.state.minsMessage !== "" ?
            this.renderTimeMessage()
            : null;

        let numParts = this.state.multiPart || this.state.numParts > 0 ?
            <div className="row no-gutters">
                <div className="col-4">
                    <p className="semibold">Total Parts:</p>
                </div>
                <div className="col">
                    <select id="total-parts" className="txt-detail" value={this.state.totalParts} onChange={this.onChangeTotalParts} >
                        <option value="1" defaultValue disabled hidden>--Select Total Number of Parts--</option>
                        <option id="2" key="2" value="2">2</option>
                        <option id="3" key="3" value="3">3</option>
                        <option id="4" key="4" value="4">4</option>
                        <option id="5" key="5" value="5">5</option>
                        <option id="6" key="6" value="6">6</option>
                        
                    </select>
                </div>
            </div>
            : null;

        let partQuestions = (jobInt < 5) ?
            <div>
                {numParts}
                {this.state.oppParts.map((oppPart, index) =>
                    <PartTypeQuestions key={`${index}-partType`} currentPart={oppPart} currentCaseId={this.state.currentOpportunity.caseId} index={index} handleChangePart={this.handleChangePart} componentList={this.state.componentList} totalParts={this.state.totalParts} />
                )}
            </div>
            : null;

        
        jobQuestions = <div>
            {partQuestions}

            <div className="row no-gutters">
                <div className="col-4">
                    <p className="semibold">Time Spent:</p>
                </div>
                <div className="col-8">
                    <div className="row no-gutters" style={{ width: '95%' }}>
                        <div className="col">
                            <input type="number" className="txt-detail" min="0" max="24" value={this.state.timeSpentHrs} placeholder="--Hours--" onChange={this.onChangeHours} />
                        </div>
                        <div className="col">
                            <input type="number" className="txt-detail" min="0" max="60" value={this.state.timeSpentMins} placeholder="--Minutes--" onChange={this.onChangeMinutes} style={{ width: 'inherit' }} />
                        </div>
                    </div>
                </div>
                {timeMessage}
            </div>
        </div>;

        return jobQuestions;
    }
    
    renderExpandContent(index, job) {

        let alertDetailsButton = (this.state.isSelected > -1 && this.state.currentOpportunity.number.includes('A')) ?
            <div>
                <button className="secondary-btn btn-small job-btn" onClick={this.onDetailsClick}>View Alert Details</button>
            </div>
            : <div />;

        let alertGraphsButton = (this.state.isSelected > -1 && this.state.currentOpportunity.number.includes('A')) ?
            <div>
                <BaseAlertPage asButton={true} alertList={this.state.alertList} getAlerts={this.getAlerts} changeRadio={this.changeRadio} reloadTable={this.reloadTable} _isMounted={this._isMounted} alertTableLoading={this.state.alertTableLoading} loading={this.state.loading} showButtons={false}
                               setCurrentPartnerId={this.props.setCurrentPartnerId} setCurrentCustomerId={this.props.setCurrentCustomerId} setActivePath={this.props.setActivePath} alertMessaging={this.state.alertMessaging} source={"CurrentJob"}/>
            </div>
            : <div />;

        let closeButton = <div>
            <button className="secondary-btn btn-small job-btn" onClick={() => this.openCloseJobModal()/*this.onCloseClick()*/}>Close Job</button>
        </div>;

        let deferrButton = <div>
            <button className="secondary-btn btn-small job-btn" onClick={() => this.openDeferJobModal(this.state.currentOpportunity)}>Defer Job</button>
        </div>;

        let jobButton = <div>
            <button className="secondary-btn btn-small job-btn" onClick={() => this.openUpdateJobModal(this.state.currentOpportunity)}>Update Job</button>
        </div>;

        let notesDetail = this.state.currentOpportunity.comment === null ?
            null
            : <p><span className={"color-grey"}>Notes</span><br />
                {(this.state.currentOpportunityDetails?.jobNotes === null || this.state.currentOpportunityDetails?.jobNotes === undefined || this.state.currentOpportunityDetails?.jobNotes === "") ? "" : this.state.currentOpportunityDetails.jobNotes}
            </p>;
        
        if (this.state.isSelected === index) {
            return (
                <tr className="expanded background-white" key={`expandedContent-${index}`}>
                    <td className={"color-unset"} colSpan={6}>
                        <div className="row">

                            <div className="col-8 offset-1 pad-left-45">
                                <h6 className="db-blue">Job Details</h6>
                                <p><span className={"color-grey"}>Scheduled For</span><br />
                                    {(this.state.currentOpportunity?.scheduledForTimeStr === "" || this.state.currentOpportunity?.scheduledForTimeStr === null || this.state.currentOpportunity?.scheduledForTimeStr === undefined) ? "Not yet scheduled" : this.getDate(this.state.currentOpportunity?.scheduledForTimeStr)}
                                </p>
                                <p><span className={"color-grey"}>Assigned To</span><br />
                                    {this.state.scheduleDetails?.technician
                                        ? this.state.scheduleDetails.technician
                                        : (this.state.currentOpportunity?.assignedToName || "Unassigned")}
                                </p>
                                <p><span className={"color-grey"}>Verification Status</span><br />
                                    {this.state.currentOpportunityDetails.isFalsePositive === null ? "Unverified" : (this.state.currentOpportunityDetails.isFalsePositive === true ? "False Positive" : "Verified")}
                                </p>
                                <p><span className={"color-grey"}>Job Value</span><br />
                                    {(this.state.currentOpportunityDetails?.impactEstimate === null || this.state.currentOpportunityDetails?.impactEstimate === undefined || this.state.currentOpportunityDetails?.impactEstimate === "") ? "Not yet provided" : String(this.state.currentOpportunityDetails.impactEstimate)}
                                </p>
                                {notesDetail}
                                <p><span className={"color-grey"}>Invoice Total</span><br />
                                    {String(this.state.scheduleDetails?.invoiceTotal)}
                                </p>
                                <p><span className={"color-grey"}> LW_JobID</span><br />
                                    {(this.state.scheduleDetails?.lwJobID === null || this.state.scheduleDetails?.lwJobID === undefined || this.state.scheduleDetails?.lwJobID === "") ? "" : this.state.scheduleDetails.lwJobID}
                                </p>
                                <p><span className={"color-grey"}>ST_ID</span><br />
                                    {(this.state.scheduleDetails?.stID === null || this.state.scheduleDetails?.stID === undefined || this.state.scheduleDetails?.stID === "") ? "" : this.state.scheduleDetails.stID}
                                </p>

                            </div>
                            <div className="col-3">
                                <h6 className="db-blue">Take Action</h6>
                                <div>
                                    {alertDetailsButton}
                                    {alertGraphsButton}
                                    {(!this.state.isCustomerSupport) && (<div>
                                        {jobButton}

                                        {closeButton}

                                        {deferrButton}
                                    </div>)}

                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            );
        }
        else
            return (<div>{null}</div>);
    }

    renderTable() {
        let scheduledContent = this.state.scheduledList !== null && this.state.scheduledList !== undefined && this.state.scheduledList.length ?
            <tbody>
                {this.state.scheduledList.map((opportunity, index) =>
                    [<tr key={opportunity.caseId} data={index} onClick={() => { this.onOpportunityClick(index) }} className={this.state.isSelected === index ? "alerts-table-selected alerts-table-row" : "alerts-table-row"}>
                        <td className={"alerts-td-left"}>{opportunity.number}</td>
                        <td>{opportunity.priorityStr}</td>
                        <td>{opportunity.subject}</td>
                        <td>{this.getDate(opportunity.createdOnTimeStr)}</td>
                        <td>{this.getDate(opportunity.scheduledForTimeStr)}</td>
                        <td className={"alerts-td-right"}>
                            {this.state.isSelected === index ?
                                <ArrowUpIcon className="db-blue-reverse border-radius-12" />
                                : <ArrowDownIcon className="db-blue db-blue-bg border-radius-12" />
                            }
                        </td>
                    </tr>,
                    this.state.isSelected === index && (this.renderExpandContent(index, opportunity))
                ])}
            </tbody>
            : <tbody>
                <tr><td>No Scheduled Opportunities</td></tr>
            </tbody>;

        let table =
            <div style={{ overflow: "auto" }}>
                <table className='table-hover width-100p' aria-labelledby="tabelLabel">
                    <thead>
                        <tr className={"alerts-table-row"}>
                            <th className={"text-center pad-10-10-10-5"}>NUMBER</th>
                            <th>PRIORITY</th>
                            <th>ISSUE</th>
                            <th>CREATED ON</th>
                            <th>SCHEDULED FOR</th>
                            <th className="table-shrink text-center pad-10-10-10-5"></th>
                        </tr>
                    </thead>
                    {scheduledContent}
                </table>
            </div>;

        return table;
    }

    renderOpportunities() {
        const { classes } = this.props;

        let opportunityLoader = this.state.opportunityLoading
            ? <Loader />
            : null;

        return (
            <div className="row no-gutters">
                <div className="col-sm-12 col-md-12">
                    <div>
                        <h5 className="sectionTitle">Leads</h5>
                        <div className={"margin-left-15 margin-right-15"}>
                            {this.renderTable()}
                        </div>
                    </div>
                    <br />
                    <p className="status-msg">{this.state.message}</p>
                </div>

                
                {opportunityLoader}
            </div>
        );
    }

    renderOpportunitiesPanel() {
        const { classes } = this.props;

        let contents = this.state.oppPanelLoading
            ? <Loader />
            : this.renderOpportunities();

        return (
            <div>
                {contents}
            </div>
        );
    }

    render() {
        const { classes } = this.props;
        
        let content = this.state.noCustomer ?
            <div><p className="status-msg">No customer selected. Please select a customer to view current job information.</p></div>
            : <div>{this.renderOpportunitiesPanel()}</div>;
        
        return (
            <div sx={(theme)=>({
                [theme.breakpoints.down('md')]: {
                    marginLeft: '-225px !important',
                },
            })}>
                <div className="infoPage">
                <h3 id="tabellabel" className="pageTitle dashboard-title" >Current Job</h3>
                    {content}
                    <ReplaceSystemModal show={this.state.showSystemModal} onClick={this.showSystemModal} onReplaceSystem={this.onReplaceSystem} ></ReplaceSystemModal>
                </div>

                <AlertDetailsModal onClick={this.openAlertDetailsModal} onCancelClick={this.onAlertCancelClick} show={this.state.showAlertDetailsConfirm} details={this.state.alertDetail} messaging={this.state.alertMessaging} asset={this.state.currentAsset} detailsLoading={this.state.detailsLoading} ></AlertDetailsModal>
                <ConfirmationModal show={this.state.showCloseJobConfirm} onYes={this.onCloseClick} onClick={this.showCloseJobModal} message={this.state.modalMessage} title={this.state.modalTitle}></ConfirmationModal>
                <ConfirmationModal show={this.state.showDeferJobConfirm} onYes={this.onDeferClick} onClick={this.showDeferJobModal} message={this.state.modalMessage} title={this.state.modalTitle}></ConfirmationModal>
                <ConfirmationModal show={this.state.showUnassignedTechConfirm} onYes={this.onUnassignedBookClick} onClick={this.showUnassignedTechModal} message={this.state.modalMessage} title={this.state.modalTitle}></ConfirmationModal>
                <ConfirmationModal show={this.state.showUnassignedTechUpdateConfirm} onYes={this.onUnassignedUpdateClick} onClick={this.showUnassignedTechUpdateModal} message={this.state.modalMessage} title={this.state.modalTitle}></ConfirmationModal>

                <UpdateJobModal show={this.state.showUpdateJobConfirm} onClick={this.showUpdateJobModal} onCancelClick={this.onCancelUpdateClick} title={this.state.modalTitle}
                                currentJob={this.state.currentOpportunity} currentJobDetails={this.state.currentOpportunityDetails} updateJob={this.state.updateOpportunity} technicianList={this.state.technicianList} selectedTechnician={this.state.selectedTechnician} scheduledDate={this.state.scheduledDateTime}
                                onChangeDate={this.onChangeScheduleDate} onChangeTechnician={this.onChangeTechnician} onChangeVerification={this.onChangeVerification}
                                onChangeJobValue={this.onChangeJobValue} onChangeNotes={this.onChangeNotes} onUpdate={this.onUpdateClick} currentPartnerSTDetails={this.state.currentPartnerSTDetails} selectedTab={this.state.tableViewType} isJobClose={this.state.isJobClose}>
                </UpdateJobModal>
                
               
            </div>
        );
    }
}

class PartTypeQuestions extends Component {

    constructor(props) {
        super(props);

        this.onChangePartType = this.onChangePartType.bind(this);
        this.onChangeOtherPart = this.onChangeOtherPart.bind(this);
        this.onChangeOEM = this.onChangeOEM.bind(this);

        this.state = {
            part: {
                caseId: this.props.currentCaseId,
                componentId: this.props.currentPart.componentId,
                oem: this.props.currentPart.oem,
                other: this.props.currentPart.other
            }
        }
    }

    onChangePartType(e) {
        let part = e.target.selectedOptions;
        let partStr = part[0].text;
        let idStr = e.target.value;
        let id = parseInt(idStr);
        let other = "None";
       
        if (partStr === "Other") {
            other = "";
        }
        else {
            other = "None"
        }

        this.setState(prevState => ({
            part: {
                ...prevState.part,
                componentId: id,
                other: other
            }
        }), () => {
            this.props.handleChangePart(this.state.part, this.props.index);
        });
    }

    onChangeOtherPart(e) {
        let other = e.target.value;

        this.setState(prevState => ({
            part: {
                ...prevState.part,
                other: other
            }
        }), () => {
            this.props.handleChangePart(this.state.part, this.props.index);
        });
    }

    onChangeOEM(e) {
        let str = e.target.value;
        let isOEM = str === "true" ? true : false;

        this.setState(prevState => ({
            part: {
                ...prevState.part,
                oem: isOEM
            }
        }), () => {
                this.props.handleChangePart(this.state.part, this.props.index);
                console.log(this.state.part);
        });
    }

    render() {
        const partIndex = this.props.index;
        const displayIndex = partIndex + 1;
        let isLast = (displayIndex === this.props.totalParts && this.props.totalParts > 1);

        return (
            <div>
                {this.props.totalParts > 1 ?
                    <div className="detailTitle">Part {displayIndex} Information</div>
                    : null
                }

                <div className="row no-gutters">
                    <div className="col-4">
                        <p className="semibold">Type of part:</p>
                    </div>
                    <div className="col">
                        <select key={`${partIndex}-partType`} id={`${partIndex}-partType`} index={partIndex} className="txt-detail" value={this.props.currentPart.componentId} onChange={this.onChangePartType}>
                            <option value="-1" disabled defaultValue hidden>--Select Part Type--</option>
                            {this.props.componentList !== null && this.props.componentList !== undefined && this.props.componentList.length ?
                                this.props.componentList.map((part, index) =>
                                    <option key={`${index}-${part.id}`} id={`${index}-${part.id}`} text={part.name} value={part.id}>{part.name}</option>
                                )
                                : null
                            }
                        </select>
                    </div>
                </div>

                {this.props.currentPart.other !== "None" ?
                    <div className="row no-gutters">
                        <div className="col-4">
                            <p className="semibold">Enter Type:</p>
                        </div>
                        <div className="col">
                            <input type="text" className="txt-detail" key={`${partIndex}-other`} id={`${partIndex}-other`} index={partIndex} value={this.props.currentPart.other} onChange={this.onChangeOtherPart} placeholder="Enter Type of Part" />
                        </div>
                    </div>
                    : null
                }

                <div className={isLast ? "row no-gutters lastItem" : "row no-gutters"} style={{ paddingLeft: '0px' }}>
                    <div className="col-4">
                        <p className="semibold">Is OEM part:</p>
                    </div>
                    <div className="col">
                        <select className="txt-detail" value={this.props.currentPart.oem} onChange={this.onChangeOEM}>
                            <option key="0" id="0" value="" disabled defaultValue hidden>--Select if OEM--</option>
                            <option key="1" id="1" value="true">Yes</option>
                            <option key="2" id="2" value="false">No</option>
                        </select>
                    </div>
                </div>

            </div>
        );
    }
} 

export default CurrentJob;


